<template>
    <widget-card
        title="Monster demand by day"
        :loading="loading"
        :error="error"
        :empty="!loading && (!payload || payload.byDay.length === 0)"
        :hidden="hidden"
        @retry="fetchData"
    >
        <div class="md-wrap" :class="{ 'is-dark': $vuetify.theme.dark }">
        <table v-if="payload && payload.byDay.length" class="md-table">
            <thead>
                <tr>
                    <th>Day</th><th>Demand</th><th>Min</th><th>Max</th><th>Refs</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in payload.byDay" :key="row.eventDayId">
                    <td>{{ row.date | luxonShortDate }}</td>
                    <td>
                        <div class="bar">
                            <div class="bar-min" :style="{ width: barMinPct(row) + '%' }"></div>
                            <div class="bar-max" :style="{ width: barMaxPct(row) + '%' }"></div>
                        </div>
                    </td>
                    <td>{{ row.minMonsters }}</td>
                    <td class="num">{{ row.maxMonsters }}</td>
                    <td>{{ row.refCover }}</td>
                </tr>
                <tr class="totals">
                    <td>All</td><td></td>
                    <td>{{ payload.totalMin }}</td>
                    <td class="num">{{ payload.totalMax }}</td>
                    <td>{{ payload.totalRefCover }}</td>
                </tr>
            </tbody>
        </table>
        <div class="legend">
            <span><i class="swatch swatch-min"></i>Min</span>
            <span><i class="swatch swatch-max"></i>Max</span>
        </div>
        </div>
    </widget-card>
</template>

<script>
import api from '@/api'
import WidgetCard from './WidgetCard.vue'

export default {
    name: 'MonsterDemandWidget',
    components: { WidgetCard },
    props: {
        eventId: { type: Number, default: null },
        mode: { type: String, default: 'mine' },
        refreshKey: { type: Number, default: 0 },
    },
    data() {
        return { loading: false, error: null, payload: null, hidden: false, inFlightKey: null }
    },
    watch: {
        eventId: { handler: 'fetchData', immediate: true },
        mode: 'fetchData',
        refreshKey: 'fetchData',
    },
    computed: {
        peakMax() {
            if (!this.payload) return 0
            return this.payload.byDay.reduce((m, r) => Math.max(m, r.maxMonsters), 0) || 1
        },
    },
    methods: {
        endpointUrl() {
            const m = this.mode.charAt(0).toUpperCase() + this.mode.slice(1)
            return `dashboard/monsterDemand/${this.eventId}?mode=${m}`
        },
        async fetchData() {
            if (!this.eventId) { this.payload = null; return }
            const key = `${this.eventId}|${this.mode}`
            this.inFlightKey = key
            this.loading = true; this.error = null; this.hidden = false
            try {
                const data = await api.get(this.endpointUrl())
                if (this.inFlightKey !== key) return
                this.payload = data
            } catch (err) {
                if (this.inFlightKey !== key) return
                if (err.response && err.response.status === 403) { this.hidden = true; return }
                this.error = err
            } finally {
                if (this.inFlightKey === key) this.loading = false
            }
        },
        barMinPct(row) { return Math.round((row.minMonsters / this.peakMax) * 100) },
        barMaxPct(row) { return Math.round(((row.maxMonsters - row.minMonsters) / this.peakMax) * 100) },
    },
}
</script>

<style scoped>
.md-table { width: 100%; font-size: 12px; border-collapse: collapse; }
.md-table th, .md-table td { padding: 4px; text-align: left; border-bottom: 1px dotted #ddd; white-space: nowrap; }
.md-table th:first-child, .md-table td:first-child { width: 1%; }
.totals td { font-weight: 600; border-bottom: none; }
.bar { display: flex; height: 10px; border-radius: 2px; overflow: hidden; background: #eee; min-width: 80px; }
.bar-min { background: #ffa000; }
.bar-max { background: #1976d2; }
.legend { display: flex; gap: 12px; font-size: 11px; margin-top: 8px; color: rgba(0,0,0,0.7); }
.swatch { display: inline-block; width: 10px; height: 10px; border-radius: 2px; margin-right: 4px; vertical-align: middle; }
.swatch-min { background: #ffa000; }
.swatch-max { background: #1976d2; }
.num { color: #1976d2; font-weight: 600; }
.md-wrap.is-dark .md-table th, .md-wrap.is-dark .md-table td { border-bottom-color: rgba(255,255,255,0.18); }
.md-wrap.is-dark .bar { background: rgba(255,255,255,0.12); }
.md-wrap.is-dark .legend { color: rgba(255,255,255,0.85); }
</style>
